const getSpecsWithTooltips = ({ specifications = [], specTips = []}) =>
  specifications.map(
    item => {
      const tooltip = specTips.find(
        tooltip => item.specName === tooltip.specName) || {}
      return { specTip: tooltip.specValue, ...item }
    }
  )

export default getSpecsWithTooltips
